export default {
  menu: {
    "Large font": "字体放大",
    "Default font": "字体缩小",
    "Total Amonut": "合计",
    "Decimal bill": "账单小数",
    "Service Fee": "服务费",
    "Thank You For Coming": "谢谢光临",
    "Tabel X Order has been checked out": "{X}号桌订单已结账",
    "We hope to serve you again next time": "我们希望下一次可以再为您服务",
    "The payment has been received": "账单已完成",
    "View membership benefits": "查看会员权益,攒积分抵消费",
    "Join Member To Enjoy Benefits": "加入会员立享优惠,攒积分抵消费",
    Check: "查看",
    "Join Member": "加入会员",
    "X Minutes before last order": "距离最后落单还有{X}分",
    "Your last food order has not been delivered yet": "您上一次食品还未送单",
    "Send out food order": "点我送单",
    "X times order": "第{X}次落单",
    "Table No.": "台号",
    Pending: "待确认",
    Notice: "公告",
    "Food are not available now": "暂无可售食品",
    pc: "/份",
    "I have read,understood and agreed to the above terms and conditions":
      "我已阅读并同意程序条款及相关隐私条款",
    Confirm: "确定",
    "Please select the number of guests": "请选择就餐人数",
    "Save to Album": "保存至相册",
    Cancel: "取消",
    "Order payment voucher,please keep it properly":
      "订单支付凭证，请妥善保管！！",
    升级: "升级",
    点餐: "点餐",
    The_self_fetching_function_is_not_available_please_contact_the_merchant:
      "自取功能不可使用,请联络餐厅",
    The_delivery_function_is_not_available_please_contact_the_merchant:
      "外送功能不可使用,请联络餐厅",
    Table_name: "台号:",
    Person: "人数",
    My_order: "我的订单",
    loading_in: "加载中...",
    No_order_at_present: "暂时没有订单",
    Opening_time: "开单时间",
    Unbind: "解绑",
    LastOrderTime: "最后落单时间",
    EndTime: "交台时间",
    appTotal: "总计",
    Bill_Decimal: "账单小数",
    appDiscount: "折扣",
    Service_amount: "服务费",
    appAmount: "总金额",
    距离X米: "距离{X}米",
    自取: "自取",
    外送: "外送",
    已售X份: "已售{X}份",
    ONE_remaining: "剩余{X}份",
    Amount: "金额",
    Also_need_to_click_$ONE_food: "还需点选{X}元食物",
    Next: "下一步",
    Remaining_QS: "还差 {X} 起送",
    shopCartN: "加购食品",
    Empty: "清空",
    Share: "一起点餐",
    Share_the_qr_Code: "分享QR Code",
    大字版: "大字版",
    Choose_a_language: "选择语言",
    Logout: "登出",
    Login: "登入",
    Not_logged_in: "未登入",
    Shop_Menu: "餐牌", // 餐牌
    Cold_Chain_Delivery: "冷冻派送",
    Takeout: "外送",
    Pick_up: "自取",
    Warm_prompt: "温馨提示",
    Max_Number: "以达到最大限制数量!",
    Over_maximum_order_quantity: "超出食品组最大限制",
    Shop_closed: "商户休息中",
    商户繁忙中: "商户繁忙中",
    服务未开启: "服务未开启",
    Takeaway_service_is_not_open: "未送服务未开启",
    Not_in_the_scope_of_delivery: "不在配送范围",
    Empty_cart: "清空购物车?",
    Please_quit_and_try_again: "请退出后重试!",
    UnbindSuccess: "解绑成功!",
    关闭: "关闭",
    结算: "结算",
    餐盒费: "餐盒费",
    共X份: "共{X}份",
    立即支付: "立即支付",
    送单成功: "送单成功!",
    确认门店地址: "确认门店地址",
    店铺: "店铺:",
    营业时间: "营业时间:",
    地址: "地址:",
    可加購X份: "可加购{X}份",
    加購以下商品享折扣: "加购以下商品享折扣",
    返回: "返回",
    撞: "撞",
    減: "减",
    此食品不參與折扣: "此食品不参与折扣",
    返回首頁將清空購物車是否返回: "返回首页将清空购物车,是否返回?",
  },
};
